import React from 'react';
import { Button, Card, List, Space, Spin, Tag, Typography } from 'antd';
import { ArrowLeftOutlined, CopyOutlined } from '@ant-design/icons';
import { formatDate } from 'utils/date';
import SampleDataModal from './SampleDataModal';

const { Text } = Typography;

const Mobile = ({ viewModel }) => {
  const {
    workspace,
    history,
    loading,
    isInvalidateShop,
    packageStatusLabel,
    packageStatusColor,
    goBack,
    demoCredentials,
    copyAllDemoCredentials,
    sampleModalOpen,
    sampleSubmitting,
    openSampleModal,
    closeSampleModal,
    createSampleData,
  } = viewModel;

  const tier = workspace?.subscription?.tier || 'mien_phi';
  const isInvalid = isInvalidateShop(workspace);

  return (
    <Spin spinning={loading}>
      <div style={{ display: 'grid', gap: 10 }}>
        <div>
          <Button icon={<ArrowLeftOutlined />} onClick={goBack}>Quay lại</Button>
        </div>

        <Button type='primary' block onClick={openSampleModal}>Tạo dữ liệu mẫu</Button>

        <Card
          title={
            <Space>
              <span>{workspace?.web_site?.title || '-'}</span>
              {workspace?.is_demo || workspace?.shop_type === 'demo' ? <Tag color='blue'>Demo</Tag> : null}
            </Space>
          }
        >
          <Space direction='vertical' size={6} style={{ width: '100%' }}>

            <Text type='secondary'>
              Domain:{' '}
              <a href={`https://${workspace?.web_site?.url}.sipro.store`} target='_blank' rel='noreferrer'>
                {workspace?.web_site?.url ? `${workspace.web_site.url}.sipro.store` : '-'}
              </a>
            </Text>
            <Text>Ngày tạo: {formatDate(workspace?.create_on) || '-'}</Text>
            <Text>Chủ shop: {workspace?.owner?.full_name || '-'}</Text>
            <Text>Số điện thoại: {workspace?.owner?.phone || '-'}</Text>
            <Text>Email: {workspace?.owner?.email || '-'}</Text>
            <Text>Sản phẩm: {workspace?.product_count ?? '-'}</Text>
            <Text>Đơn tháng này: {workspace?.order_count_month ?? '-'}</Text>
          </Space>
        </Card>

        <Card title='Gói cước đang sử dụng'>
          <Space direction='vertical' size={4}>
            <Space>
              <Text>Gói: {isInvalid ? 'invalidate' : (tier || '-')}</Text>
              {isInvalid ? <Tag color='red'>Invalidate</Tag> : null}
            </Space>
            {tier !== 'mien_phi' && (
              <Text type='secondary'>Hết hạn: {formatDate(workspace?.subscription?.expiry_on) || '-'}</Text>
            )}
          </Space>
        </Card>

        {demoCredentials && (
          <Card title='Thông tin đăng nhập demo'>
            <Space direction='vertical' size={8} style={{ width: '100%' }}>
              <Space>
                <Text type='secondary'>Login ID:</Text>
                <Text copyable={{ text: demoCredentials.login_id || '' }}>{demoCredentials.login_id || '-'}</Text>
              </Space>
              <Space>
                <Text type='secondary'>Mật khẩu:</Text>
                <Text copyable={{ text: demoCredentials.password || '' }}>{demoCredentials.password || '-'}</Text>
              </Space>
              <Space>
                <Text type='secondary'>URL:</Text>
                <a href={`https://${workspace?.web_site?.url}.sipro.store`} target='_blank' rel='noreferrer'>
                  {workspace?.web_site?.url ? `${workspace.web_site.url}.sipro.store` : '-'}
                </a>
              </Space>
              <Button block icon={<CopyOutlined />} onClick={copyAllDemoCredentials}>
                Copy tất cả
              </Button>
            </Space>
          </Card>
        )}

        <Card title='Lịch sử nâng hạ gói'>
          <List
            dataSource={history}
            locale={{ emptyText: 'Chưa có lịch sử' }}
            renderItem={(record) => (
              <List.Item style={{ padding: '8px 0', borderBottom: '1px solid #f0f0f0' }}>
                <Space direction='vertical' size={2} style={{ width: '100%' }}>
                  <Space>
                    <Text strong>{record.package_name || record.package_key || '-'}</Text>
                    <Tag color={packageStatusColor(record.status)}>{packageStatusLabel(record.status)}</Tag>
                  </Space>
                  <Text type='secondary'>
                    Thời hạn: {record.total_months || record.duration_months || '-'} tháng
                  </Text>
                  {record.amount ? (
                    <Text>Số tiền: {Number(record.amount).toLocaleString('vi-VN')} ₫</Text>
                  ) : null}
                  <Text type='secondary'>Ngày tạo: {formatDate(record.create_on) || '-'}</Text>
                  {record.approved_on ? (
                    <Text type='secondary'>Ngày duyệt: {formatDate(record.approved_on) || '-'}</Text>
                  ) : null}
                </Space>
              </List.Item>
            )}
          />
        </Card>

        <SampleDataModal
          open={sampleModalOpen}
          loading={sampleSubmitting}
          onCancel={closeSampleModal}
          onSubmit={createSampleData}
        />

      </div>
    </Spin>
  );
};

export default Mobile;
